import { useTranslation } from "react-i18next";
import { AGENT_ENDPOINT } from "../../lib/agentMembers";

/** How an AI service connects with the key: the endpoint and the Authorization header. */
export function AgentConnectHelp() {
  const { t } = useTranslation();
  return (
    <div className="p-3 bg-muted rounded-lg text-sm space-y-2">
      <p className="font-medium text-foreground">{t("agent.connect.title")}</p>
      <p className="text-muted-foreground">{t("agent.connect.help")}</p>
      <dl className="space-y-1">
        <div>
          <dt className="text-xs text-muted-foreground">{t("agent.connect.endpoint")}</dt>
          <dd><code className="break-all">{AGENT_ENDPOINT}</code></dd>
        </div>
        <div>
          <dt className="text-xs text-muted-foreground">{t("agent.connect.header")}</dt>
          <dd><code className="break-all">Authorization: Bearer &lt;key&gt;</code></dd>
        </div>
      </dl>
    </div>
  );
}
